import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(form) {
    return baseApi.post(`/api-registration/v1/registration-deadline`, form);
  },
  remove(id) {
    return baseApi.delete(`/api-registration/v1/registration-deadline/${id}`);
  }
}
